import { EventSchema } from '@common/schemas/entities/event.schema';
import { z } from 'zod';

/** DTO shape = raw Firestore document, inferred from common EventSchema */
export type EventDTO = z.infer<typeof EventSchema>;

export const EventFormSchema = EventSchema.omit({ audit: true }).extend({
  id: z.string().optional(),
}).passthrough();

export type EventFormValues = z.infer<typeof EventFormSchema>;
